module.exports = __webpack_public_path__ + "img/payment.081c2a0e.svg";